/**
 * Account Deactivated Page
 *
 * Shown when a user's team membership has been deactivated
 */

import { useMsal } from '@azure/msal-react';
import { UserX, LogOut, Mail } from 'lucide-react';

export default function AccountDeactivated() {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sca-purple-500 to-sca-pink-500 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8">
        {/* Icon */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 mb-4">
            <UserX className="w-8 h-8 text-amber-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Account Deactivated</h1>
        </div>

        {/* Message */}
        <div className="text-center mb-8">
          <p className="text-gray-600 mb-4">
            Your Operations Hub account has been deactivated.
          </p>
          <p className="text-gray-500 text-sm">
            This may have been done by an administrator. If you believe this is
            an error, please contact your team administrator to have your
            account reactivated.
          </p>
        </div>

        {/* Contact info */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <div className="flex items-center gap-3 text-gray-600">
            <Mail className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">Need help?</p>
              <p className="text-sm text-gray-500">
                Contact your team administrator to reactivate your account
              </p>
            </div>
          </div>
        </div>

        {/* Sign out button */}
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
        >
          <LogOut className="w-4 h-4" />
          Sign out
        </button>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} Sudden Cardiac Arrest UK.
            All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
